export default __webpack_public_path__ + "static/media/Logo.412e8c26.svg";